"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Maintenance = function Maintenance() {
  return _react2.default.createElement(
    "g",
    { id: "maintenance" },
    _react2.default.createElement("path", {
      d: "M107,160.7 C63.5,203.9 58.1,270.7 90.8,319.6 L54.5,355.7 C2.3,286.4 7.5,188 71,125 C105.7,90.5 151.2,73.2 196.8,73.2 L196.8,0 L304.7,107.1 L196.8,214.3 L196.8,123.6 C164.3,123.8 131.8,136.1 107,160.7 Z M372.7,223.2 C368.4,195.3 357.4,168 339.3,144.3 L303,180.4 C335.7,229.3 330.3,296.1 286.8,339.3 C262,363.9 229.5,376.3 196.9,376.4 L196.9,285.7 L89,392.9 L196.8,500 L196.8,426.8 C242.5,426.8 287.9,409.5 322.6,375 C350.5,347.3 367,312.7 372.6,276.8 L481.5,276.6 L481.5,223.4 L372.7,223.2 Z",
      id: "Fill-144"
    })
  );
};

exports.default = Maintenance;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Maintenance.js
// module id = 2967
// module chunks = 4